(function () {
  'use strict';
  if (window.KSLegacyClickTracker) return;
  window.KSLegacyClickTracker = true;
  document.addEventListener('click', function (event) {
    try {
      if (window.KSBrandTrackingConfig?.isThemeEditor) return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      const layer = window.dataLayer;
      if (!layer || typeof layer.push !== 'function') return;
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (link.matches('a[data-ks-world-nav]') && link.closest('.ks-world-nav')) {
        if (link.dataset.ksWorldNav && /^\/(pages|collections|products)(\/|$)/.test(url.pathname)) {
          layer.push({event: 'ks_world_click', world: link.dataset.ksWorldNav});
        }
        return;
      }
      const product = link.closest('[data-ks-product]');
      if (product?.dataset.ksProduct && /^\/products\//.test(url.pathname)) {
        layer.push({event: 'ks_product_click', product: product.dataset.ksProduct});
      }
    } catch (_) {}
  });
})();
